import React from 'react'
import {List, ListItem} from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import Cached from '@material-ui/icons/Cached'
import OpenWith from '@material-ui/icons/OpenWith'
const SideControl = ({onMouseDownRotate, onMouseDownMove, onClickDelete}) => {
  return (
    <List className="ap-barcode-rrd-control__side-control">
      <ListItem
        className="ap-barcode-rrd-control__side-control-item ap-barcode-rrd-control__side-control-item--drag"
        onMouseDown={onMouseDownMove}
      >
        <OpenWith />
      </ListItem>
      <ListItem
        className="ap-barcode-rrd-control__side-control-item ap-barcode-rrd-control__side-control-item--drag"
        onMouseDown={onMouseDownRotate}
      >
        <Cached />
      </ListItem>
      <ListItem
        className="ap-barcode-rrd-control__side-control-item"
        onMouseDown={e => e.preventDefault()}
        onClick={onClickDelete}
      >
        <CancelIcon />
      </ListItem>
    </List>
  )
}

export default SideControl
